module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": "0.2rem 0 3rem 0"
    }
  }, [(_vm.formData.saiqu.need_video == 1) ? _c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "value": _vm.formData.saiqu.name,
      "title": "赛区"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.baoming.danwei,
      "title": "单位"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.baoming.mingcheng,
      "title": "队伍名称"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.subject_name,
      "title": "项目"
    }
  }), _vm._v(" "), (_vm.formData.subject_name.indexOf('活力大课间啦啦操展示') >= 0) ? _c('van-cell', {
    attrs: {
      "input-align": "right",
      "label": "如果不上传运动员信息，请填写运动员人数",
      "title": "运动员人数"
    }
  }, [(_vm.formData.subject_name.indexOf('活力大课间啦啦操展示') >= 0) ? _c('van-stepper', {
    attrs: {
      "integer": "",
      "min": 0,
      "max": 3000
    },
    model: {
      value: (_vm.formData.yundongyuan_count),
      callback: function($$v) {
        _vm.$set(_vm.formData, "yundongyuan_count", $$v)
      },
      expression: "formData.yundongyuan_count"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.subject_name.indexOf('活力大课间啦啦操展示') >= 0) ? _c('van-cell', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.pcUrl),
      expression: "pcUrl",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    attrs: {
      "title": "导入运动员信息",
      "value": "点击复制网址",
      "is-link": ""
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('div', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("如果不填写运动员，后期将无法导出证书。")])])], 2) : _vm._e(), _vm._v(" "), (_vm.canSubmit) ? _c('van-cell', {
    attrs: {
      "title": "视频",
      "value": _vm.formData.video.length + '/1'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canSubmit && _vm.formData.video.length == 0 && _vm.isAndroid && _vm.isApp) ? _c('div', {
    staticClass: "row",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.beforeUpload($event)
      }
    }
  }, [_c('div', {
    staticClass: "uploader-wrap"
  }, [_c('div', {
    staticClass: "uploader-content"
  }, [_c('van-icon', {
    attrs: {
      "name": "video",
      "size": "24",
      "color": "#dcdee0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uploader-text",
    staticStyle: {
      "color": "#969799",
      "font-size": "12px"
    }
  }, [_vm._v("\n              上传视频\n            ")])], 1)])]) : (_vm.canSubmit) ? _c('div', {
    staticClass: "row"
  }, [_c('VideoUploader', {
    ref: "vu",
    attrs: {
      "maxSize": _vm.formData.saiqu.id == 767 ? 500 : 200,
      "minSize": 0,
      "fileList": _vm.formData.video,
      "limit": 1,
      "fileName": _vm.formData.baoming.mingcheng + '-' + _vm.formData.subject_name,
      "name": 'video'
    },
    on: {
      "onInputClick": _vm.onVideoInputClick
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canSubmit && _vm.formData.video.length == 0) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请上传一段视频")]) : _vm._e(), _vm._v(" "), (_vm.canSubmit && _vm.formData.video.length > 0) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_c('van-button', {
    attrs: {
      "native-type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delVideo()
      }
    }
  }, [_vm._v("删除视频")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "native-type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.playVideo()
      }
    }
  }, [_vm._v("视频预览")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isApp),
      expression: "isApp"
    }],
    staticStyle: {
      "padding": "10px 15px",
      "background": "#fffbe8",
      "color": "#ed6a0c"
    },
    on: {
      "click": _vm.onDownload
    }
  }, [_vm._v("如果视频无法上传，请点击这里下载最新版")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.pcUrl),
      expression: "pcUrl",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticStyle: {
      "padding": "10px 15px",
      "margin-top": "20px",
      "background": "#fffbe8",
      "color": "#333",
      "text-align": "center"
    }
  }, [_vm._v("\n        还可以复制以下网址用电脑浏览器上传\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.pcUrl) + "\n        "), _c('br'), _vm._v("\n        点击复制\n      ")])], 1), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交完成上传")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32be1806","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormUploadVideo.vue
// module id = 2296
// module chunks = 0